module.exports = __webpack_public_path__ + "static/media/Start_pin.d62c12cf.png";